import React from 'react'
import { Switch, withStyles } from '@material-ui/core'

const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 34,
    height: 18,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.colors['grey-200'],
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.colors['green-500'],
      margin: '0px -2px',
      '& + $track': {
        backgroundColor: 'transparent',
        borderColor: theme.colors['green-500'],
        opacity: 1,
      },
    },
    '&$checked$disabled': {
      color: theme.colors['grey-100'],
      '& + $track': {
        borderColor: theme.colors['grey-100'],
        backgroundColor: 'transparent',
        opacity: 1,
      },
    },
    '&$disabled': {
      color: theme.colors['grey-100'],
      '& + $track': {
        borderColor: theme.colors['grey-100'],
        backgroundColor: 'transparent',
        opacity: 1,
      },
    },
  },
  thumb: {
    width: 10,
    height: 10,
    boxShadow: 'none',
    margin: '2px',
  },
  track: {
    borderRadius: 12,
    border: `3px solid ${theme.colors['grey-200']}`,
    backgroundColor: 'transparent',
    opacity: 1,
    transition: 'border-color 0.3s',
  },
  checked: {},
  disabled: {},
}))(Switch)

const Switchs = (prop) => {
  return <CustomSwitch {...prop} />
}

export default Switchs
